const apis = {
    post_save_company: "/signin",
    post_save_client: "/admin/usuarios/registro/cliente"
}

export default apis;